import { Box } from '@mantine/core';
import type { ReactElement, ReactNode } from 'react';
import ResponsiveRow from '@/shared/responsive/ResponsiveRow';
import DrillBreadcrumb, { type BreadcrumbItem } from '@/design/DrillBreadcrumb';

interface SurfaceBreadcrumbRowProps {
    items: BreadcrumbItem[];
    /** Right-aligned content (the "Ask me anything" bar) that shares the breadcrumb's row. */
    right?: ReactNode;
}

/**
 * The drill breadcrumb paired with right-aligned content on a single row, so the
 * "Ask me anything" bar aligns with the breadcrumb on the drill pages (L1/L2)
 * instead of sitting in the page-title toolbar. Stacks to a column on mobile.
 */
export default function SurfaceBreadcrumbRow({ items, right }: SurfaceBreadcrumbRowProps): ReactElement {
    return (
        <ResponsiveRow gap="sm" mb="md">
            <Box style={{ minWidth: 0, flex: 1 }}>
                <DrillBreadcrumb items={items} mb={0} />
            </Box>
            {right !== undefined && <Box style={{ flexShrink: 1, minWidth: 0 }}>{right}</Box>}
        </ResponsiveRow>
    );
}
